class ProductPickerCTA extends HTMLElement {
  constructor() {
    super();
    this.addToCartButtons = document.querySelectorAll(
      "button[data-variant-id]"
    );
    this.addToCartButtons.forEach((button) => {
      this.buttonEventListener(button);
    });
  }

  buttonEventListener(button) {
    button.addEventListener("click", (event) => {
      if (button.disabled) return;

      this.variantId = event.currentTarget.getAttribute("data-variant-id");
      this.setButtonState(button, "loading");
      this.addToCart(this.variantId, button);
    });

    button.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        button.click();
      }
    });
  }

  addToCart(variantId, button) {
    fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        note: `product:  ${variantId}`,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === 422) {
          throw new Error(data.message || "Unable to add item to cart");
        } else {
          this.setButtonState(button, "success");
          this.announceSuccess(button);

          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: data,
              },
            })
          );

          setTimeout(() => {
            this.setButtonState(button, "default");
          }, 2000);
        }
      })
      .catch((error) => {
        console.error("Add to cart error:", error);
        this.setButtonState(button, "error");
        this.announceError(button, error.message);

        setTimeout(() => {
          this.setButtonState(button, "default");
        }, 3000);
      });
  }

  setButtonState(button, state) {
    const textSpan = button.querySelector("[data-add-to-cart-text]");
    const glitchSpan = button.querySelector("[data-glitch-text]");
    const statusSpan = button.querySelector("[data-button-status]");

    button.classList.remove("loading", "error", "success");

    switch (state) {
      case "loading":
        button.classList.add("loading");
        button.disabled = true;
        const loadingText = textSpan.dataset.loadingText || "Adding...";
        textSpan.textContent = loadingText;
        if (glitchSpan) glitchSpan.textContent = loadingText;
        break;
      case "error":
        button.classList.add("error");
        button.disabled = false;
        const errorText = textSpan.dataset.errorText || "Try again";
        textSpan.textContent = errorText;
        if (glitchSpan) glitchSpan.textContent = errorText;
        break;
      case "success":
        button.classList.add("success");
        button.disabled = false;
        const successText = "Added!";
        textSpan.textContent = successText;
        if (glitchSpan) glitchSpan.textContent = successText;
        break;
      default:
        button.disabled = false;
        const defaultText = textSpan.dataset.defaultText || "Add to cart";
        textSpan.textContent = defaultText;
        if (glitchSpan) glitchSpan.textContent = defaultText;
    }
  }

  announceSuccess(button) {
    const statusSpan = button.querySelector("[data-button-status]");
    const variantTitle = button
      .getAttribute("aria-label")
      .replace("Add ", "")
      .replace(" to cart", "");
    statusSpan.textContent = `${variantTitle} added to cart successfully`;

    setTimeout(() => {
      statusSpan.textContent = "";
    }, 3000);
  }

  announceError(button, message) {
    const statusSpan = button.querySelector("[data-button-status]");
    statusSpan.textContent = `Error: ${message}. Please try again.`;

    setTimeout(() => {
      statusSpan.textContent = "";
    }, 5000);
  }
}

window.addEventListener("DOMContentLoaded", () =>
  customElements.define("product-picker-cta", ProductPickerCTA)
);
